export default {
  API_BASE_URL: "https://morning-brushlands-99211.herokuapp.com/api/",
  SOCKET_END_POINT: "https://morning-brushlands-99211.herokuapp.com/",
  EVENTS: {
    PLAYERS_CHANGED: "playersChanged",
    GAME_STARTED: "gameStarted",
  },
};
